<template>
  <div class="record">
    <div class="table-list" v-if="tableData.length != 0">
      <el-table :data="tableData" v-loading="loading">
        <el-table-column
          width="50"
          label="序号"
          type="index"
          align="center"
        ></el-table-column>
        <el-table-column align="center" label="授权对象">
          <template slot-scope="scope">
            {{ scope.row.authorization.userName }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="授权文件">
          <template slot-scope="scope">
            <div>{{ scope.row.authorization.fileName }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="授权时间">
          <template slot-scope="scope">
            {{ scope.row.authorization.createTime }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <img
              :src="require('assets/images/download-blue.png')"
              @click="downLoad(scope.row.authorization)"
              style="vertical-align: middle; cursor: pointer; margin-left: 10px"
              alt=""
            />
            <span
              style="color: #4587ff; cursor: pointer"
              @click="downLoad(scope.row.authorization)"
              >下载授权证书</span
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="currentChange"
        :current-page="page"
        :page-size="limit"
        :pager-count="5"
        layout="total, prev, pager, next, jumper"
        :total="pageTotal"
      >
      </el-pagination>
    </div>
    <div class="kong" v-else>
      <img :src="require('assets/images/kong.png')" alt="" />
      <div>暂无记录</div>
    </div>
  </div>
</template>

<script>
import { assemblyList } from "api/infoCompile";
import { authorizationList } from "api/copyrightIncome";
import { isHasFreeCount } from "api/common";
export default {
  name: "Record",
  data() {
    return {
      page: 1,
      limit: 10,
      tableData: [],
      loading: false,
      pageTotal: 0,
    };
  },
  created() {
    this.initList();
  },
  methods: {
    async initList() {
      const data = {
        page: 1,
        limit: 10,
        type: 1,
      };
      // authorizationList
      const res = await authorizationList(data);
      this.tableData = res.data.data;
      this.pageTotal = res.data.total;
      this.loading = false;
      // console.log(res);
    },
    currentChange(val) {
      this.page = val;
      this.initList();
    },
    async handleClick(item) {
      const flieName = item.assemblyUrl.split("/");
      console.log("汇编成册" + flieName[flieName.length - 1]);
      try {
        // eslint-disable-next-line
        OpenDocument2(
          "汇编成册" + flieName[flieName.length - 1],
          item.assemblyUrl
        );
      } catch (e) {
        console.log(e);
      }
    },
    // DownloadDocument
    downLoad(item) {
      const flieName = item.url.split("/");
      // console.log("汇编成册" + flieName[flieName.length - 1]);
      try {
        // eslint-disable-next-line
        DownloadDocument(
          "授权证书" + flieName[flieName.length - 1],
          this.$store.state.onlineBasePath + item.url
        );
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.record {
  // height: calc(100vh - 115px);
  padding: 0 20px;
  box-sizing: border-box;
  position: relative;
  .kong {
    margin-top: 10%;
    text-align: center;
    img {
      width: 150px;
      height: 150px;
    }
  }
  .table-list {
    max-height: 95%;
    overflow: auto;
    ::v-deep .el-pagination {
      width: 95%;
      box-sizing: border-box;
      text-align: center;
      // position: absolute;
      bottom: 0;
    }
    ::v-deep .el-table {
      .el-table__body-wrapper {
        .states {
          display: inline-block;
          // width: 60px;
          padding: 0 5px;
        }
        .gray {
          display: inline-block;
          background: url("~assets/images/rhombus-gray.png") no-repeat;
          background-size: 100% 100%;

          color: #999;
        }

        .green {
          // width: 100%;
          display: inline-block;
          // position: absolute;
          // height: 100%;
          background: url("~assets/images/rhombus-green.png") no-repeat;
          background-size: 100% 100%;
          color: #fff;
          font-size: 12px;
        }
        .red {
          // width: 100%;
          display: inline-block;
          // position: absolute;
          // height: 100%;
          background: url("~assets/images/rhombus-red.png") no-repeat;
          background-size: 100% 100%;
          color: #fff;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
